// Opens a URL in a new tab safely
export function openLinkInNewTab(url: string) {
  if (!url) return;
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
}